import './style.css';

import Add from '@mui/icons-material/Add';
import DoNotDisturbAltIcon from '@mui/icons-material/DoNotDisturbAlt';
import SaveIcon from '@mui/icons-material/Save';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { isAfter, isEqual, startOfDay } from 'date-fns';
import moment from 'moment';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import swal from 'sweetalert';

import { savePermiso } from './../../../redux/Permisos/PermisosSlice';

import { selectAllEmpleados } from '../../../redux/Empleados/EmpleadosSlice';

import dayjs from 'dayjs';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};

const PermisoNuevo = ({
  open,
  setOpen,
  setOpenFirma,
  validacionFirmaEmpleado,
  vacacionesInfoState = {},
  inputEmployeeDisabled = false,
  tiposPermisosCategoriaGrupo = [],
}) => {
  // ? HOOK-FORM
  const form = useFormContext();
  const {
    control,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
    register,
    watch,
  } = form;

  // ? HOOK-DISPATCH
  const dispatch = useDispatch();

  // ? HOOK-WATCH FECHA DE INICIO
  const fechaInicio = useWatch({
    control,
    name: 'fechaInicio',
  });

  // ? HOOK-WATCH CHECKED-RECURRENTE
  const checkedRecurrente = useWatch({
    control,
    name: 'recurrencia.recurrente',
  });

  // ? HOOK-WATCH CHECKED-DIA-COMPLETO
  const tipoPermisoId = useWatch({
    control,
    name: 'tipoPermisoId',
  });

  // ? HOOK SELECTOR
  const empleadosList = useSelector(selectAllEmpleados);

  const onSubmit = (data) => {
    if (!data) {
      return;
    }

    if (!validacionFirmaEmpleado) {
      setOpenFirma(true);
      return;
    }

    swal({
      title: 'Desea utilizar la firma actualmente registrada en el sistema?',
      text: 'Puede cambiar la firma al pulsar la opción CAMBIAR FIRMA',
      icon: 'warning',
      dangerMode: true,
      buttons: {
        cancelar: {
          text: 'Cancelar',
          value: false,
          visible: true,
          className: 'btn btn-danger swal-button',
          closeModal: true,
        },
        cambiar: {
          text: 'Cambiar firma',
          value: null,
          visible: true,
          className: 'btn btn-success',
          closeModal: true,
        },
        usarFirma: {
          text: 'Usar firma registrada',
          value: true,
          visible: true,
          className: 'btn btn-primary-mem',
          closeModal: true,
        },
      },
    }).then((answer) => {
      if (answer === null) {
        setOpenFirma(true);
      } else if (answer) {
        dispatch(savePermiso(data));
      }
    });
  };

  // * FUNCION PARA CERRAR EL MODAL.
  const handleClose = () => {
    setOpen(false);
    reset();
  };

  return (
    <Modal open={open} onClose={handleClose} aria-labelledby="parent-modal-title" aria-describedby="parent-modal-description">
      <Box sx={{ ...style, width: 700 }}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="container">
            <div className="row">
              <h3 className="text-primary-mem text-center">Solicitar Permiso Personalizado</h3>
            </div>
            <div className="row">
              <div className="col-5 me-0 pe-0">
                <hr />
              </div>
              <div className="col-2 text-center">
                <Add className="text-primary-mem" />
              </div>
              <div className="col-5 ms-0 ps-0 ">
                <hr />
              </div>
            </div>
            <div className="row">
              <div className="form-group">
                <label className="fw-bold">Empleado</label>

                <Controller
                  control={control}
                  {...register('empleadoId', {
                    required: 'El empleado es requerido',
                  })}
                  render={({ field }) => (
                    <Select
                      id="select-empleado"
                      isDisabled={inputEmployeeDisabled}
                      classNamePrefix="select"
                      isSearchable={true}
                      placeholder="Seleccionar Empleado"
                      options={empleadosList}
                      getOptionLabel={(option) => option.nombreLabel}
                      getOptionValue={(option) => option.id}
                      onChange={(e) => field.onChange(e.id)}
                      value={empleadosList.find((x) => x.id === field.value)}
                    />
                  )}
                />

                <p className="text-danger mb-0">{errors?.empleadoId?.message}</p>
              </div>
              <div className="form-group">
                <label className="fw-bold">Tipo Permiso</label>

                <Controller
                  control={control}
                  name="tipoPermisoId"
                  rules={{
                    required: 'El tipo de permiso es requerido',
                    validate: (value) => value !== 0 || 'El permiso es requerido',
                  }}
                  render={({ field }) => (
                    <Select
                      classNamePrefix="select"
                      isSearchable={true}
                      placeholder="Seleccionar Tipo Permiso"
                      options={tiposPermisosCategoriaGrupo}
                      onChange={(e) => field.onChange(e.value)}
                      defaultValue={field.value}
                    />
                  )}
                />
                <p className="text-danger mb-0">{errors?.tipoPermisoId?.message}</p>
              </div>
              <div className="form-group">
                <label className="fw-bold">Dias</label>
                <input type="number" disabled className="form-control" value={watch('dias')} />

                <p className="text-danger mb-0">{errors?.dias?.message}</p>
              </div>

              <div className="row mb-2 mt-2" hidden={tipoPermisoId !== 2}>
                <div className="col">
                  <label style={{ fontSize: 14 }}>
                    <b>Años trabajados:</b> {vacacionesInfoState?.cantidadAñosTrabajados}
                  </label>
                </div>
                <div className="col">
                  <label style={{ fontSize: 14 }}>
                    <b>Cantidad de días:</b> {vacacionesInfoState?.cantidadDiasVacacionesPorAñoTrabajado}
                  </label>
                </div>
              </div>

              <div className="row">
                <div className="col">
                  <div className="form-group">
                    <label className="fw-bold">Fecha inicio</label>
                    <Controller
                      control={control}
                      name="fechaInicio"
                      rules={{
                        required: 'La fecha de inicio es requerida',
                      }}
                      render={({ field }) => (
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DatePicker
                            inputFormat="dd/MM/yyyy"
                            label={' '}
                            mask="__/__/____"
                            value={field.value}
                            onChange={(e) => field.onChange(e)}
                            renderInput={(params) => <TextField height={10} className="form-control" style={{ height: 10 }} {...params} />}
                          />
                        </LocalizationProvider>
                      )}
                    />
                    <p className="text-danger mt-3 mb-0">{errors?.fechaInicio?.message}</p>
                  </div>
                </div>
                <div className="col">
                  <div className="form-group">
                    <label className="fw-bold">Fecha Término</label>
                    <Controller
                      control={control}
                      name="fechaTermino"
                      rules={{
                        required: 'La fecha de término es requerida',
                        validate: (value) => {
                          const fechaTermino = startOfDay(new Date(value));
                          const fechaInicioAjustada = startOfDay(new Date(fechaInicio));
                          return (
                            isAfter(fechaTermino, fechaInicioAjustada) ||
                            isEqual(fechaTermino, fechaInicioAjustada) ||
                            'La fecha de término debe ser mayor o igual a la fecha de inicio'
                          );
                        },
                      }}
                      render={({ field }) => (
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DatePicker
                            minDate={startOfDay(new Date(fechaInicio)) - 1}
                            inputFormat="dd/MM/yyyy"
                            label={' '}
                            mask="__/__/____"
                            value={field.value ? startOfDay(new Date(field.value)) : null}
                            onChange={(date) => {
                              // Ajustar siempre al inicio del día
                              const fechaAjustada = startOfDay(new Date(date));
                              field.onChange(fechaAjustada);
                            }}
                            renderInput={(params) => <TextField height={10} className="form-control" style={{ height: 10 }} {...params} />}
                          />
                        </LocalizationProvider>
                      )}
                    />
                    <p className="text-danger mt-3 mb-0">{errors?.fechaTermino?.message}</p>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="form-group">
                    <label className="fw-bold">Hora inicio</label>
                    <Controller
                      control={control}
                      name="horaInicio"
                      rules={{
                        required: 'La hora es requerida',
                        validate: (value) => {
                          if (!value) {
                            return 'La hora es obligatoria';
                          }
                          if (!dayjs(value).isValid()) {
                            return 'Hora inválida';
                          }
                          return true;
                        },
                      }}
                      render={({ field }) => (
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <TimePicker
                            value={field.value ?? null}
                            label={' '}
                            onChange={(e) => field.onChange(moment(e).format('yyyy-MM-DD HH:mm:ss'))}
                            renderInput={(params) => <TextField height={10} className="form-control" style={{ height: 10 }} {...params} />}
                          />
                        </LocalizationProvider>
                      )}
                    />
                    <p className="text-danger mt-3 mb-0">{errors?.horaInicio?.message}</p>
                  </div>
                </div>
                <div className="col">
                  <div className="form-group">
                    <label className="fw-bold">Hora Término</label>
                    <Controller
                      control={control}
                      name="horaTermino"
                      rules={{
                        required: 'La hora es requerida',
                        validate: (value) => {
                          if (!value) {
                            return 'La hora es obligatoria';
                          }
                          if (!dayjs(value).isValid()) {
                            return 'Hora inválida';
                          }
                          return true;
                        },
                      }}
                      render={({ field }) => (
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <TimePicker
                            value={field.value ?? null}
                            label={' '}
                            onChange={(e) => {
                              field.onChange(moment(e).format('yyyy-MM-DD HH:mm:ss'));
                            }}
                            renderInput={(params) => <TextField height={10} className="form-control" style={{ height: 10 }} {...params} />}
                          />
                        </LocalizationProvider>
                      )}
                    />
                    <p className="text-danger mt-3 mb-0">{errors?.horaTermino?.message}</p>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="form-group">
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Controller
                            name="diaCompleto"
                            control={control}
                            defaultValue={false}
                            render={({ field }) => <Checkbox disabled checked={!!field.value} onChange={(e) => field.onChange(e.target.checked)} />}
                          />
                        }
                        label="Día Completo"
                      />
                    </FormGroup>
                  </div>
                </div>
                <div className="col">
                  <div className="form-group">
                    <FormGroup>
                      <FormControlLabel control={<Checkbox {...register('recurrencia.recurrente')} />} label="Permiso Recurrente" />
                    </FormGroup>
                  </div>
                </div>
              </div>
              <div className="col-md-12">
                <div className="row border me-1 ms-1">
                  <div className="col-3">
                    <div className="form-group">
                      <FormGroup>
                        <FormControlLabel
                          sx={{
                            '& .MuiTypography-root': {
                              fontSize: { lg: 14, md: 12, xs: 11 },
                            },
                          }}
                          control={
                            <Checkbox
                              disabled={!checkedRecurrente}
                              value={watch('recurrencia.l')}
                              checked={watch('recurrencia.l')}
                              onChange={(e) => {
                                const isChecked = e.target.checked;
                                setValue(`recurrencia.l`, isChecked);
                              }}
                            />
                          }
                          label="Lunes"
                        />
                      </FormGroup>
                    </div>
                  </div>
                  <div className="col">
                    <div className="form-group">
                      <FormGroup>
                        <FormControlLabel
                          sx={{
                            '& .MuiTypography-root': {
                              fontSize: { lg: 14, md: 12, xs: 11 },
                            },
                          }}
                          control={
                            <Checkbox
                              disabled={!checkedRecurrente}
                              value={watch('recurrencia.m')}
                              checked={watch('recurrencia.m')}
                              onChange={(e) => {
                                const isChecked = e.target.checked;
                                setValue(`recurrencia.m`, isChecked);
                              }}
                            />
                          }
                          label="Martes"
                        />
                      </FormGroup>
                    </div>
                  </div>
                  <div className="col">
                    <div className="form-group">
                      <FormGroup>
                        <FormControlLabel
                          sx={{
                            '& .MuiTypography-root': {
                              fontSize: { lg: 14, md: 12, xs: 11 },
                            },
                          }}
                          control={
                            <Checkbox
                              disabled={!checkedRecurrente}
                              value={watch('recurrencia.x')}
                              checked={watch('recurrencia.x')}
                              onChange={(e) => {
                                const isChecked = e.target.checked;
                                setValue(`recurrencia.x`, isChecked);
                              }}
                            />
                          }
                          label="Miércoles"
                        />
                      </FormGroup>
                    </div>
                  </div>
                  <div className="col">
                    <div className="form-group">
                      <FormGroup>
                        <FormControlLabel
                          sx={{
                            '& .MuiTypography-root': {
                              fontSize: { lg: 14, md: 12, xs: 11 },
                            },
                          }}
                          control={
                            <Checkbox
                              disabled={!checkedRecurrente}
                              value={watch('recurrencia.j')}
                              checked={watch('recurrencia.j')}
                              onChange={(e) => {
                                const isChecked = e.target.checked;
                                setValue(`recurrencia.j`, isChecked);
                              }}
                            />
                          }
                          label="Jueves"
                        />
                      </FormGroup>
                    </div>
                  </div>
                  <div className="col">
                    <div className="form-group">
                      <FormGroup>
                        <FormControlLabel
                          sx={{
                            '& .MuiTypography-root': {
                              fontSize: { lg: 14, md: 12, xs: 11 },
                            },
                          }}
                          control={
                            <Checkbox
                              disabled={!checkedRecurrente}
                              value={watch('recurrencia.v')}
                              checked={watch('recurrencia.v')}
                              onChange={(e) => {
                                const isChecked = e.target.checked;
                                setValue(`recurrencia.v`, isChecked);
                              }}
                            />
                          }
                          label="Viernes"
                        />
                      </FormGroup>
                    </div>
                  </div>
                  <div className="col">
                    <div className="form-group">
                      <FormGroup>
                        <FormControlLabel
                          sx={{
                            '& .MuiTypography-root': {
                              fontSize: { lg: 14, md: 12, xs: 11 },
                            },
                          }}
                          control={
                            <Checkbox
                              disabled={!checkedRecurrente}
                              value={watch('recurrencia.s')}
                              checked={watch('recurrencia.s')}
                              onChange={(e) => {
                                const isChecked = e.target.checked;
                                setValue(`recurrencia.s`, isChecked);
                              }}
                            />
                          }
                          label="Sábado"
                        />
                      </FormGroup>
                    </div>
                  </div>
                  <div className="col">
                    <div className="form-group">
                      <FormGroup>
                        <FormControlLabel
                          sx={{
                            '& .MuiTypography-root': {
                              fontSize: { lg: 14, md: 12, xs: 11 },
                            },
                          }}
                          control={
                            <Checkbox
                              disabled={!checkedRecurrente}
                              value={watch('recurrencia.d')}
                              checked={watch('recurrencia.d')}
                              onChange={(e) => {
                                const isChecked = e.target.checked;
                                setValue(`recurrencia.d`, isChecked);
                              }}
                            />
                          }
                          label="Domingo"
                        />
                      </FormGroup>
                    </div>
                  </div>
                  <div className="col">
                    <div className="form-group" hidden>
                      <FormGroup>
                        <FormControlLabel control={<Checkbox />} label="Domingo" />
                      </FormGroup>
                    </div>
                  </div>
                </div>
              </div>
              <div className="form-group">
                <label className="fw-bold">Comentario</label>

                <textarea className="form-control" {...register('justificacion')} rows={2} />
              </div>

              <div className="d-flex justify-content-center mt-3">
                <button id="btn-guardar" type="submit" className="btn btn-primary-mem me-3">
                  <SaveIcon sx={{ marginTop: -0.5, marginRight: 0.5 }} /> Guardar
                </button>

                <button id="btn-cancelar" type="button" className="btn btn-danger " onClick={handleClose}>
                  <DoNotDisturbAltIcon sx={{ marginTop: -0.5, marginRight: 0.5 }} />
                  Cancelar
                </button>
              </div>
            </div>
          </div>
        </form>
      </Box>
    </Modal>
  );
};

export default PermisoNuevo;
